import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import RangeSlider from "@/components/RangeSlider";

interface ImportanceSectionProps {
  values: [number, number];
  labels: Array<{ value: string; label: string }>;
  isPro: boolean;
  isDirty?: boolean;
  onChange: (values: [number, number]) => void;
}

const ImportanceSection: React.FC<ImportanceSectionProps> = ({
  values,
  labels,
  isPro,
  onChange
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>重要度の配分</CardTitle>
      </CardHeader>
      <CardContent className="px-4">
        <RangeSlider 
          values={values}
          labels={labels}
          isPro={isPro}
          onChange={onChange}
        />
      </CardContent>
    </Card>
  );
};

export default ImportanceSection;
